import { Component, Inject } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { TranslateService } from '@services/translate/translate.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProfileService } from '@services/profiles/profile.service';

@Component({
    selector: 'app-add-new-profile',
    templateUrl: './add-new-token.component.html',
    styleUrls: ['./add-new-token.component.scss'],
    providers: [ProfileService],
    standalone: false
})
export class AddNewToken {
  type = '';
  token: Models.ExternalToken;
  ibex2Token: string;

  constructor(
    private dialogRef: MatDialogRef<AddNewToken>, @Inject(MAT_DIALOG_DATA) public data: any, private translate: TranslateService, private profileService: ProfileService
  ) {
    this.translate.get('');
    this.token = new Models.ExternalToken();
  }

  abort() {
    this.dialogRef.close();
  }

  async save() {
    if (this.type === 'ibex2') {
      this.token.title = 'ibexinfo';
      this.token.logo = 'https://ibexfusion5.s3.eu-central-1.amazonaws.com/general/ibexinfo.png';
      this.token.endpoint = 'https://ibex2reloaded.ibexfusion.com/ibex/ngauth.php';
      this.token.type = 'post';
      this.token.target = 'blank';
      this.token.parameters = [{ name: 'token', value: this.ibex2Token, encrypted: true } as any];
    }
    this.dialogRef.close(this.token);
  }

  addParameter() {
    if (!this.token.parameters) {
      this.token.parameters = [];
    }
    this.token.parameters.push(new Models.LoginParameter());
  }

  removeParameter(index) {
    this.token.parameters.splice(index, 1);
  }
}
